module.exports = __webpack_public_path__ + "img/book4-active.e6dca059.png";